import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SpinnerComponent } from '../spinner/spinner.component';

type ColorType = 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning' | 'muted' | 'neutral' | 'none' | 'outline' | 'disabled';

@Component({
  selector: 'lib-button',
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatTooltipModule,
    SpinnerComponent
  ],
  standalone: true,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})

export class ButtonComponent {
  @Input() text: string = '';
  // Defaults to 'button' so a lib-button never triggers an implicit form submit when placed inside a <form>.
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() color: ColorType = 'primary';
  @Input() darkColor: ColorType | '' = '';
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  /** Name of a registered custom SVG icon (MatIconRegistry), used instead of a font ligature icon. */
  @Input() svgIcon: string = '';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() tooltip: string = '';
  /** Accessible name for the button. Falls back to `tooltip` so icon-only buttons still get a name. */
  @Input() ariaLabel: string = '';
  @Input() textColor: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning' | 'muted' | 'neutral' | 'disabled' | '' = '';
  @Input() noHover: boolean = false;
  @Input() loading?: boolean;
  @Input() current?: number;
  @Input() total?: number;
  @Input() customClass: string = '';

  get hasProgress(): boolean {
    return this.current != null && this.total != null && this.total > 0;
  }

  get progressPercent(): number {
    return Math.round((this.current! / this.total!) * 100);
  }
  @Output() click: EventEmitter<any> = new EventEmitter<any>();

  onClick(event: Event) {
    event.stopPropagation();
    if (this.disabled || this.loading) return;

    if (this.click) {
      this.click.emit();
    }
  }
}
